import "./App.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Route, Routes } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import ViewCoApplicant from "./pages/CoApplicant/ViewCoApplicant/ViewCoApplicant";
import AddCoApplicant from "./pages/CoApplicant/AddCoApplicant/AddCoApplicant";
import AddCollateral from "./pages/Collateral/AddCollateral/AddCollateral";
import ViewCollateral from "./pages/Collateral/ViewCollateral/ViewCollateral";
import AddLoan from "./pages/Loan/AddLoan";
import EditLead from "./pages/Lead/EditLead/EditLead";
import Login from "./pages/Login/Login";
import ViewBorrower from "./pages/Borrower/ViewBorrower/ViewBorrower";
import EditBorrower from "./pages/Borrower/EditBorrower/EditBorrower";
import AddLead from "./pages/Lead/AddLead/AddLead";
import ViewLead from "../src/pages/Lead/ViewLead/ViewLead";
import BorrowerDetails from "../src/pages/Borrower/BorrowerDetails/BorrowerDetails";
import CreatedLoans from "./pages/Loan/CreatedLoans/CreatedLoans";
import LeadToBorrower from "./pages/Lead/LeadToBorrower/LeadToBorrower";
import ViewLoanDetails from "./pages/Loan/ViewLoanDetails/ViewLoanDetails";
import EditCoApplicant from "../src/pages/CoApplicant/EditCoapplicant/EditCoApplicant";
import EditCollateral from "../src/pages/Collateral/EditCollateral/EditCollateral";
import EditLoan from "./pages/Loan/EditLoan/EditLoan";
import CpvCases from "./pages/Loan/CpvCases/CpvCases";
import Reports from "./pages/Reports/Reports";
import BulkUpload from "./pages/BulkUpload/BulkUpload";
import Dashboard from "./pages/Dashboard/Dashboard";
import StagingLogin from "./pages/Login/StagingLogin";
import ProtectedRoute from "./pages/ProtectedRoute/ProtectedRoute";
import Cookies from "js-cookie";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import ViewCoapplicantDetails from "./pages/CoApplicant/ViewCoapplicantDetails/CoapplicantDetails";
import ViewCollateralDetails from "./pages/Collateral/ViewCollateralDetails/CollateralDetails";
import FrontPage from "./pages/Borrower/BorrowerDetails/Components/SectionTwo/Components/Analysis/Components/CustomerVideoPage/FrontPage";
import VideoPage from "./pages/Borrower/BorrowerDetails/Components/SectionTwo/Components/Analysis/Components/CustomerVideoPage/VideoPage";
import Bureau from "./pages/Bureau/Bureau";
import LogsMain from "./pages/LogsPage/LogsMain";
import { fetchGeolocation } from "./utils/fetchLocation";
import MeetingPage from "./pages/Borrower/BorrowerDetails/Components/SectionTwo/Components/Analysis/Components/PD/MeetingPage";
import { BorrowerContextProvider } from "./pages/Borrower/BorrowerDetails/store/borrower-details";
import BorrowerDetailsScreen from "./pages/Borrower/ViewBorrower/BorrowerDetailsScreen";
import ViewPersonalDetailsScreen from "./pages/Borrower/ViewBorrower/ViewPersonalDetailsScreen";
import EditBorrowerScreen from "./pages/Borrower/ViewBorrower/EditBorrowerScreen";
import NewAddLoan from "./pages/Loan/NewAddLoan";
import NewEditLoan from "./pages/Loan/NewEditLoan";
import UploadKYCDocs from "./pages/Borrower/ViewBorrower/UploadKYCDocs";

axios.interceptors.request.use(
  async (config) => {
    if (config.url?.includes("adddocument")) {
      // console.log(config.data)
      try {
        const location = await fetchGeolocation();
        if (location.latitude && location.longitude) {
          if (config.data) {
            config.data.latitude = location.latitude;
            config.data.longitude = location.longitude;
          } else {
            config.data = {
              latitude: location.latitude,
              longitude: location.longitude,
            };
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    return config
  })
export const version = 1.1;
let url;
let consoleUrl;
let collectionUrl;

if (window.location.href.includes("localhost")) {
  url = "http://localhost:5000";
  // url = `http://staging.cpanel.api.credin.in`;
  consoleUrl = `http://staging.console.api.credin.in`;
  collectionUrl = `http://staging.collections.credin.in`;
} else if (window.location.href.includes("staging")) {
  url = `http://staging.cpanel.api.credin.in`;
  consoleUrl = `http://staging.console.api.credin.in`;
  collectionUrl = `http://staging.collections.credin.in`;
} else {
  url = "https://cpanelapi.credin.in";
  // url = "https://testcpanelapi.credin.in";
  consoleUrl = "https://consoleapi.credin.in";
  collectionUrl = "https://collections.api.credin.in";
}

export { url, consoleUrl, collectionUrl };

function App() {
  const queryClient = new QueryClient();
  const [AddLeadVisible, setAddLeadVisible] = useState(true);
  const [ViewLeadVisible, setViewLeadVisible] = useState(true);
  const [ViewBorrowerVisible, setViewBorrowerVisible] = useState(true);
  const [ViewLoanVisible, setViewLoanVisible] = useState(true);
  const [CpvCasesVisible, setCpvCasesVisible] = useState(true);
  const [ViewCoapplicantVisible, setViewCoapplicantVisible] = useState(true);
  const [ViewCollateralVisible, setViewCollateralVisible] = useState(true);
  const [ReportsVisible, setReportsVisible] = useState(true);
  const [BulkUploadVisible, setBulkUploadVisible] = useState(true);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");

  useEffect(() => {
    axios
      .post(url + "/user/check/session", {
        token: token === undefined ? "NA" : token,
        email: email === undefined ? "NA" : email,
      })
      .then((res) => {
        if (email !== "rupesh.bishnoi@credin.in") {
          setAddLeadVisible(res.data.userData.permission.add_lead);
          setViewLeadVisible(res.data.userData.permission.view_lead);
          setViewBorrowerVisible(res.data.userData.permission.view_borrower);
          setViewLoanVisible(res.data.userData.permission.view_loan);
          setCpvCasesVisible(res.data.userData.permission.view_cpv_case);
          setViewCoapplicantVisible(
            res.data.userData.permission.view_co_borrower
          );
          setViewCollateralVisible(
            res.data.userData.permission.view_collateral
          );
          setReportsVisible(
            res.data.userData.permission.borrower_report_types ||
            res.data.userData.permission.loan_report_report_types ||
            res.data.userData.permission.disbursement_report_report_types ||
            res.data.userData.permission.master_report_report_types ||
            res.data.userData.permission.resolved_query ||
            res.data.userData.permission.raised_query ||
            res.data.userData.permission.rfd_report_report_types ||
            res.data.userData.permission.coapplicant_report_report_types ||
            res.data.userData.permission.loan_application_report_types ||
            res.data.userData.permission.loan_dynamic_application_report_types

          );
          setBulkUploadVisible(
            res.data.userData.permission.bulk_upload_borrower ||
            res.data.userData.permission.bulk_upload_co_borrower ||
            res.data.userData.permission.bulk_upload_collateral ||
            res.data.userData.permission.bulk_upload_lead ||
            res.data.userData.permission.bulk_upload_loan
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [token, email]);
  console.log("APP")
  return (
    <>
      <div className="root-lms">
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  url === "http://staging.cpanel.api.credin.in" ||
                    url.includes("localhost") ? (
                    <StagingLogin />
                  ) : (
                    <Login />
                  )
                }
              />
              {(document.body.style = "background:  #EDF5FF")}
              <Route
                path="/coapplicant/view"
                element={
                  <ProtectedRoute user={ViewCoapplicantVisible}>
                    <ViewCoApplicant />
                  </ProtectedRoute>
                }
              />
              <Route path="/coapplicant/add" element={<AddCoApplicant />} />
              <Route path="/coapplicant/edit" element={<EditCoApplicant />} />

              <Route path="/collateral/add"
                element={
                  <BorrowerContextProvider>
                    <AddCollateral />
                  </BorrowerContextProvider>
                }
              />

              <Route path="/collateral/edit"
                element={
                  <BorrowerContextProvider>
                    <EditCollateral />
                  </BorrowerContextProvider>
                }
              />

              <Route
                path="/collateral/view"
                element={
                  <ProtectedRoute user={ViewCollateralVisible}>
                    <ViewCollateral />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/borrower/view"
                element={
                  <ProtectedRoute user={ViewBorrowerVisible}>
                    <ViewBorrower />
                  </ProtectedRoute>
                }
              />
              <Route path="/borrower/edit" element={<EditBorrower />} />
              <Route path="/borrower/lead" element={<LeadToBorrower />} />
              <Route path="/borrower/detail/:loanid" element={<BorrowerDetails />} />
              <Route
                path="/lead/add"
                element={
                  <ProtectedRoute user={AddLeadVisible}>
                    <AddLead />
                  </ProtectedRoute>
                }
              />
              <Route path="/lead/edit" element={<EditLead />} />
              <Route
                path="/lead/view"
                element={
                  <ProtectedRoute user={ViewLeadVisible}>
                    <ViewLead />
                  </ProtectedRoute>
                }
              />
              <Route path="/loan/add" element={<AddLoan />} />
              <Route path="/loan/edit" element={<EditLoan />} />
              <Route
                path="/loan/created"
                element={
                  <ProtectedRoute user={ViewLoanVisible}>
                    <CreatedLoans />
                  </ProtectedRoute>
                }
              />
              <Route path="/viewLoanDetails" element={<ViewLoanDetails />} />
              <Route
                path="/loan/CpvCases"
                element={
                  <ProtectedRoute user={CpvCasesVisible}>
                    <CpvCases />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute user={ReportsVisible}>
                    <Reports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bulkUpload"
                element={
                  <ProtectedRoute user={BulkUploadVisible}>
                    <BulkUpload />
                  </ProtectedRoute>
                }
              />
              <Route path="/home" element={
                  <Dashboard /> } 
                />
              <Route
                path="/viewcoapplicantdetails"
                element={<ViewCoapplicantDetails />}
              />
              <Route
                path="/viewcollateraldetails"
                element={<ViewCollateralDetails />}
              />
              <Route path="/bureau" element={<Bureau />}
              />
              <Route path="/vpd/pd" element={<FrontPage />} />
              <Route path="/vpd/join/pd" element={<VideoPage />} />
              <Route path="/logs" element={<LogsMain />} />
              <Route path="/vpd" element={
                <BorrowerContextProvider>
                  <MeetingPage />
                </BorrowerContextProvider>
              } />

              {/* new routes */}
              <Route
                path="/single/borrower/details/:id"
                element={
                  <BorrowerContextProvider>
                    <BorrowerDetailsScreen />
                  </BorrowerContextProvider>
                }
              />
              <Route
                path="/view/personal/details/:id"
                element={
                  <BorrowerContextProvider>
                    <ViewPersonalDetailsScreen />
                  </BorrowerContextProvider>
                }
              />
              <Route path="/edit/borrower/screen/:id" element={<EditBorrowerScreen />} />
              <Route
                path="/add/new/loan"
                element={
                  <BorrowerContextProvider>
                    <NewAddLoan />
                  </BorrowerContextProvider>
                }
              />
              <Route
                path="/edit/new/loan/:loanid"
                element={
                  <BorrowerContextProvider>
                    <NewEditLoan />
                  </BorrowerContextProvider>
                }
              />
              <Route path="/upload/kyc/docs/:id" element={
                <BorrowerContextProvider>
                  <UploadKYCDocs />
                </BorrowerContextProvider>
              }
              />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </div>
    </>
  );
}

export default App;
